import { Grid, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import {
  getPetAndAppointmentDetailsById,
  getPetsCompliantSummaryWoLoader,
} from "../../../redux/reducers/petSlice";
import {
  getCardColorByApptStatus,
  getRightSaluation,
  getTypeByAppointmentType,
} from "../../../util/function";
import CommonClinicPetDetails from "../../CommonScreens/CommonClinicPetDetails/CommonClinicPetDetails";
import UpdateRemarks from "../../CommonScreens/UpdateRemarks/UpdateRemarks";
import Billing from "../ClinicPetDetails/Billing/Billing";
import MedicalHistoryNew from "../ClinicPetDetails/MedicalHistory/MedicalHistoryNew";
import Files from "../ClinicPetDetails/PatientWorkbook/Files";
import PetDiagnostics from "../ClinicPetDetails/PatientWorkbook/PetDiagnostics";
import SoapNotesNew from "../ClinicPetDetails/PatientWorkbook/SoapNotesNew";
import WorkBookHistory from "../ClinicPetDetails/PatientWorkbook/WorkBookHistory";

const overviewSubTabs = ["Diagnostics", "SOAP Notes", "Records"];

export const LAB_PET_DETAIL_TAB_PATHS = {
  overView: "overview",
  billing: "billing",
  history: "history",
};

export const LAB_PET_DETAIL_PATH_TO_TAB = {
  overview: "overView",
  billing: "billing",
  history: "history",
};

export const LabPetDetailsRedirect = () => {
  const location = useLocation();
  const tabFromNav = location.state?.selectedTab;
  const path =
    LAB_PET_DETAIL_TAB_PATHS[tabFromNav] ?? LAB_PET_DETAIL_TAB_PATHS.overView;
  const nextState = {
    ...(location.state || {}),
    selectedTab: LAB_PET_DETAIL_PATH_TO_TAB[path] ?? "overView",
  };
  return <Navigate to={`/lab-pet-details/${path}`} replace state={nextState} />;
};

const LabPetDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { tab } = useParams();
  const { appointment } = location.state || {};
  const selectedTab = LAB_PET_DETAIL_PATH_TO_TAB[tab];
  const [isVideoCallEnabled, setVideoCallEnabled] = useState(false);
  const [scrollable, setScrollable] = useState(true);
  const [inpatientId, setInpatientId] = useState(location?.state?.inpatientId);
  const [allergyModOpen, setAllergyModOpen] = useState(false);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [selectedBill, setSelectedBill] = useState(
    location?.state?.bill ?? null,
  );
  const [finModVsble, setFinModVsble] = useState(false);
  const [isSumamryView, setIsSumamryView] = useState(false);
  const [overviewSubTab, setOverviewSubTab] = useState("Diagnostics");
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { apiInProgress } = useSelector((state) => state?.clinic);
  const petAndApntData = useSelector(
    (state) => state?.pet?.petAndAppointmentDetails,
  );
  const appDet = petAndApntData?.appointment;
  const appointmentId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const isAnyApiInProgress =
    apiInProgress?.soapGeneration ||
    apiInProgress?.clinicNotesPost ||
    apiInProgress?.clinicNotesPut ||
    apiInProgress?.consolidateSoap;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { vets: clinicVets } = useMemo(() => {
    if (!mandateDataRaw) {
      return { vets: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return { vets: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    if (!petId) return;
    dispatch(
      getPetAndAppointmentDetailsById({
        petId,
        url: `${appointmentId ? `?appointmentId=${appointmentId}` : ""}`,
      }),
    );
    if (appointmentId) dispatch(getPetsCompliantSummaryWoLoader(appointmentId));
  }, [appointmentId, petId, dispatch]);

  useEffect(() => {
    const { bill } = location.state || {};
    if (bill) {
      setSelectedBill(bill);
    }
  }, [location.state?.bill]);

  const handleTabNavigation = (tabId) => {
    if (!tabId || tabId === selectedTab) return;

    const path =
      LAB_PET_DETAIL_TAB_PATHS[tabId] ?? LAB_PET_DETAIL_TAB_PATHS.overView;
    navigate(`/lab-pet-details/${path}`, {
      state: {
        ...(location.state || {}),
        selectedTab: tabId,
      },
    });
  };

  const setSelectedTab = (tabIdOrUpdater) => {
    const nextTab =
      typeof tabIdOrUpdater === "function"
        ? tabIdOrUpdater(selectedTab)
        : tabIdOrUpdater;
    handleTabNavigation(nextTab);
  };

  const onCloseRemarks = () => {
    setRemarksModVsble(false);
  };

  const handlePaymentView = () => {
    if (reqDet?.paymentId && reqDet?.appointment?.appointmentId) {
      setSelectedBill({
        paymentId: reqDet?.paymentId,
        appointmentId: reqDet?.appointment?.appointmentId,
      });
      navigate(`/lab-pet-details/${LAB_PET_DETAIL_TAB_PATHS.billing}`, {
        state: {
          ...(location.state || {}),
          selectedTab: "billing",
          bill: {
            paymentId: reqDet?.paymentId,
            appointmentId: reqDet?.appointment?.appointmentId,
          },
        },
      });
    }
  };

  const handleCloseBill = () => {
    setSelectedBill(null);
    navigate(`/lab-pet-details/${LAB_PET_DETAIL_TAB_PATHS.overView}`, {
      state: {
        ...(location.state || {}),
        selectedTab: "overView",
        bill: null,
      },
    });
  };

  const onFinalize = () => {
    setIsSumamryView(false);
    setFinModVsble(true);
  };

  const handleFinalize = () => {};

  if (!selectedTab) {
    return (
      <Navigate
        to={`/lab-pet-details/${LAB_PET_DETAIL_TAB_PATHS.overView}`}
        replace
        state={location.state}
      />
    );
  }

  const onSelectOverviewSubTab = (sub) => {
    if (["SOAP Notes", "Records"].includes(sub) && appointmentId) {
      dispatch(getPetsCompliantSummaryWoLoader(appointmentId));
    }
    setOverviewSubTab(sub);
  };

  return (
    <>
      <CommonClinicPetDetails
        upcomingVisible={false}
        isVideoCallEnabled={isVideoCallEnabled}
        setVideoCallEnabled={setVideoCallEnabled}
        appointment={appointment}
        scrollable={scrollable}
        setSelectedTab={setSelectedTab}
        setInpatientId={setInpatientId}
        allergyModOpen={allergyModOpen}
        setAllergyModOpen={setAllergyModOpen}
        selectedTab={selectedTab}
        setScrollable={setScrollable}
      >
        <Grid container className="ph2">
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white p10 bs-margin"
          >
            <div className="flex-row">
              <div
                className="ph10pv3"
                onClick={() => handleTabNavigation("overView")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "overView"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  Overview
                </div>
              </div>
              <div
                className="ph10pv3"
                onClick={() => handleTabNavigation("history")}
              >
                <div
                  className={`flex-center cursor ${
                    selectedTab === "history"
                      ? "pet-det-sel-tab"
                      : "pet-det-un-sel-tab"
                  }`}
                >
                  History
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
        {selectedTab === "billing" ? (
          <div className="mtMin20 w100Per">
            <Billing
              bill={selectedBill}
              setSelectedBill={setSelectedBill}
              setEditBill={(val) => {
                if (!val) handleCloseBill();
              }}
            />
          </div>
        ) : selectedTab === "history" ? (
          <MedicalHistoryNew
            petId={appointment?.appoinment?.petId}
            apntId={appointment?.appoinment?.appointmentId ?? null}
          />
        ) : (
          <div className="scroll-80vh">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mh10">
                <div className="appointmentBdrlft cardWHeader br8">
                  <div className="bg-body bdrBtm flex-row-between-align-center pt10 pb10 pl15 pr15">
                    <Typography className="fs13 txt-semi-bold clr-dark-gray">
                      Appointment Details
                    </Typography>
                    <div className="flex-row">
                      {appDet?.appointmentStatus === "completed" &&
                      !appDet?.lock ? null : (
                        <div>
                          <CustomButton
                            text="View Bill"
                            smallBtn
                            onClick={handlePaymentView}
                            whiteBtn
                          />
                        </div>
                      )}
                      {appDet?.appointmentStatus === "consultation" ||
                      (appDet?.inpatient &&
                        appDet?.appointmentStatus === "recovery") ? (
                        <div className="ml15">
                          <CustomButton
                            text="Finalize"
                            smallBtn
                            onClick={onFinalize}
                            disabled={
                              isAnyApiInProgress ||
                              (appDet?.appointmentStatus !== "consultation" &&
                                !appDet?.inpatient)
                            }
                            grayBtn={
                              isAnyApiInProgress ||
                              (appDet?.appointmentStatus !== "consultation" &&
                                !appDet?.inpatient)
                            }
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="gry-hor-split3" />
                  <div className="pt10 pb10 pl15 pr15">
                    <div className="flex-row-between">
                      <div>
                        <div className="flex-row-ali-cen">
                          <Typography className="fs14 txt-semi-bold">
                            {`Meeting ${getRightSaluation(clinicVets, appDet?.doctorId)}
                            ${appDet?.doctorName}
                            ${
                              appDet?.facilityId && appDet?.facility
                                ? ` · Facility: ${appDet?.facility}`
                                : ""
                            }
                            `}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen">
                          <Typography className="fs12 font-medium clr-dark-gray">
                            {`${appDet?.serviceType} · ${moment(appDet?.appointmentdateTime).format("DD MMM YYYY, HH:mm")}${(appDet?.caseId ?? "")?.toString()?.length > 0 ? ` · Case ID - ${appDet?.caseId}` : ""}`}
                          </Typography>
                        </div>
                      </div>
                      <div>
                        <div className="flex-row-ali-cen">
                          <Typography
                            className={`font-medium fs10 pv2 ph10 white-color br5
                                              flex-center  ${
                                                appDet?.appointmentType ===
                                                "Physical"
                                                  ? "card-bot-blue-back"
                                                  : "virtual-bg"
                                              }`}
                          >
                            {appDet?.appointmentType === "Home"
                              ? "Home Visit"
                              : appDet?.appointmentType}
                          </Typography>
                          <Typography
                            className={`ml10 fs10 txt-semi-bold white-color con-fit flex-center ph10 pv2 br5 ${getCardColorByApptStatus(
                              appDet?.appointmentStatus?.toLowerCase(),
                              appDet?.appointmentType,
                            )}`}
                          >
                            {getTypeByAppointmentType(
                              appDet?.appointmentStatus,
                              appDet?.appointmentType,
                            )}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div className="flex-row-ali-cen mt5">
                      <Typography className="clr-dark-gray fs12 font-medium">
                        Remarks:
                      </Typography>
                      <Typography className="fs12 txt-regular ml5">
                        {appDet?.remarks?.length > 0 ? appDet?.remarks : "---"}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <div>
              <div className="bs-margin pb10 mt10">
                <div className="flex-row">
                  {overviewSubTabs.map((sub) => (
                    <Typography
                      key={sub}
                      className={`ml20 newTab cursor ${
                        overviewSubTab === sub ? "newTabSelected" : ""
                      }`}
                      onClick={() => onSelectOverviewSubTab(sub)}
                    >
                      {sub}
                    </Typography>
                  ))}
                </div>
              </div>
              {overviewSubTab === "SOAP Notes" ? (
                <SoapNotesNew appointment={appointment} />
              ) : overviewSubTab === "Records" ? (
                <Files />
              ) : (
                <PetDiagnostics />
              )}
            </div>
          </div>
        )}
      </CommonClinicPetDetails>
      {remarksModVsble ? (
        <UpdateRemarks
          remarksModVsble={remarksModVsble}
          onCloseRemarks={onCloseRemarks}
          remarks={appDet?.remarks}
          notes={appDet?.notes}
          id={appDet?.appointmentId}
        />
      ) : null}
      {finModVsble ? (
        <WorkBookHistory
          finModVsble={finModVsble}
          setFinModVsble={setFinModVsble}
          handleFinalize={handleFinalize}
          isSumamryView={isSumamryView}
        />
      ) : null}
    </>
  );
};

export default LabPetDetails;
